import React, { useState, useEffect } from "react";
import { Box, Text, Spinner } from "@chakra-ui/react";

function EnderecoPorCoordenadas({ latitude, longitude }) {
  const [endereco, setEndereco] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (latitude && longitude) {
      // URL para a API Nominatim do OpenStreetMap
      const url = `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json&addressdetails=1`;

      // Fetching the address from Nominatim
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          setEndereco(data.address); // Armazenar o endereço na variável de estado
          setLoading(false);
        })
        .catch((err) => {
          setError("Não foi possível obter o endereço.");
          setLoading(false);
        });
    }
  }, [latitude, longitude]);

  if (loading) {
    return (
      <Box p={4} textAlign="center">
        <Spinner size="lg" />
        <Text>Carregando endereço...</Text>
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={4} textAlign="center" color="red.500">
        <Text>{error}</Text>
      </Box>
    );
  }

  return (
    <Box p={1}>
      {endereco ? (
        <Box>
          <Text fontSize="sm" fontWeight="bold">
            Endereço:
          </Text>
          <Text fontSize="sm" color="gray">
            {endereco.road || "Endereço não disponível"},
          </Text>
          <Text fontSize="sm" color="gray">
            {endereco.city ||
              endereco.town ||
              endereco.village ||
              "Cidade não disponível"}
            ,
          </Text>
          <Text color="gray" fontSize="x-small">
            {endereco.country || "País não disponível"}
          </Text>
        </Box>
      ) : (
        <Text>Endereço não encontrado.</Text>
      )}
    </Box>
  );
}

export default EnderecoPorCoordenadas;
